<template>
  <div id="product">
    <SfBreadcrumbs class="breadcrumbs desktop-only" :breadcrumbs="breadcrumbs" />
    <div class="product">
      <gallery  ref="SfGallerGoodInfo" :thumbWidth="120" :thumbHeight="120" :imageWidth="imageWidth" :imageHeight="imageWidth"
        :images="productGallery" class="product__gallery">
        <template v-slot:thumbs="props">
          <Sf-button v-for="(image, index) in props.images" :key="'img-' + index"
            class="sf-button--pure sf-gallery__item" :class="{ 'sf-gallery__item--selected': index === props.active }"
            :aria-label="'Image ' + index" @click="go(index)">
            <div style="height:100%;width:100%;">
              <SfImage v-if="image.fileType == 'image'" class="sf-gallery__thumb" :src="image.mobile.url"
                :alt="image.alt" :placeholder="image.placeholder" :nuxt-img-config="{}" :height="120" :width="120" />
              <span v-else>
                <video class="sf-image sf-gallery__thumb" ref="galleryVideo"
                  style="opacity:1;width:100%;height:100%;" preload="metadata" playsinline :autoplay="true">
                  <source :src="image.mobile.url" :type="'video/' + image.houzhui">
                </video>
                <div style="opacity: 0;height:100%;width:100%;"></div>
              </span>
            </div>
          </Sf-button>
        </template>
        <template v-slot:big-image="props1">
          <div>
            <Sf-image
              :id="'goodsfGalleryBigSku' + props1.index" class="sf-gallery__big-image"
              :class="{ 'sf-gallery__big-image--has-zoom': props1.enableZoom }" :src="skuImage"
              :alt="props1.picture.alt" :placeholder="props1.picture.placeholder" :width="props1.imageWidth || 620"
              :height="props1.imageHeight || 620" :image-tag="props1.imageTag"
              :nuxt-img-config="props1.nuxtImgConfig"/>
            <Sf-image v-if="props1.picture.fileType == 'image'" ref="sfGalleryBigImage"
              :id="'goodsfGalleryBig' + props1.index" class="sf-gallery__big-image"
              :class="{ 'sf-gallery__big-image--has-zoom': props1.enableZoom }" :src="props1.picture.desktop.url"
              :alt="props1.picture.alt" :placeholder="props1.picture.placeholder" :width="props1.imageWidth || 620"
              :height="props1.imageHeight || 620" :image-tag="props1.imageTag"
              :nuxt-img-config="props1.nuxtImgConfig" />
            <video v-else :id="'goodsfGalleryBig' + props1.index" :autoplay="true" muted preload="load" loop
              ref="sfGalleryBigImage" :src="props1.picture.desktop.url" :width="props1.imageWidth || '100%'"
              :height="'auto' || '100%'" style="object-position: top;max-height:620px;"
              :class="{ 'sf-gallery__big-image': true, 'sf-gallery__big-image--has-zoom': props1.enableZoom }"
               playsinline>
              <source :src="props1.picture.desktop.url" :type="'video/' + props1.picture.houzhui">
            </video>
          </div>
        </template>
      </gallery>
      <div class="product__info" style="width:100%;max-width: 28rem;margin-left:0rem;">
        <div class="product__header">
          <SfHeading :level="3" class="sf-heading--no-underline sf-heading--left">
            <template #title>
              <div>
                <h1 style="font-size: var(--font-size--base);font-weight:600;width:100%;">
                  {{ productGetters.getName(product) }}
                </h1>
              </div>
            </template>
          </SfHeading>
          <SfIcon icon="drag" size="xxl" color="var(--c-text-disabled)" class="product__drag-icon smartphone-only" />
        </div>
        <p v-if="product && product.subTitle" class="product__description">
          {{ product.subTitle }}
        </p>
        <p v-if="product && product.shopName" class="product__description">
          <span @click="goLink(product.shopDomain)" style="cursor:pointer;">
            {{ product.shopName }}
            <SfIcon  icon="home_fill" size="1.1rem" viewBox="0 0 32 32" :coverage="1"
              style="margin-left: 2px;display: inline;line-height: 24px;" />
          </span>
        </p>
        <div class="product__price-and-rating">
            <div class="product__rating">
              <SfRating :score="averageRating" :max="5" />
              <a href="#ReadReviews" class="product__count">
                <span v-if="reviewTotal">{{ totalReviews }}</span> <span v-if="reviewTotal" style="text-decoration: underline;">{{ $t('Read_reviews') }}</span>
              </a>
            </div>
        </div>
        <div class="product__price-and-rating">
          <getDiscount v-if="product && product.goodId" :goods="product" :sku="CurrentSku" :showBtn="true" :autoLing="true" />
        </div>
        <div>
          <wholesale style="margin-bottom: var(--spacer-sm);" v-if="product && product.goodId" typeStyle="row2" :id="product.goodId" />
        </div>
        <!-- <div class="goodPostage">
          <getPostage :sku="CurrentSku" />
        </div> -->
        <div style="width:100%;">
          <div  class="product__price-and-rating">
            <div>
              <Sku v-if="product &&
              product.skus &&
              product.skus.length &&
              product.skuProps &&
              product.skuProps.length
              " :goodInfo="product" @changeSelectedSku="selectSku" />
            </div>
          </div>
           <div class="productRemark" v-if="goodInfoRemark && goodInfoRemark.content" style="margin-bottom: var(--spacer-lg);" >
              <div v-html="goodInfoRemark.content"></div>
          </div>
        </div>
        <LazyHydrate when-idle>
          <div>
              <div>
                <SfAccordion class="productAcction" :multiple="true">
                  <SfAccordionItem v-for="goodHtml in goodInfosVhtml" :key="goodHtml.name" :header="goodHtml.name" class="filters__accordion-item">
                    <div class="product__description">
                      <div v-html="goodHtml.value"></div>
                    </div>
                  </SfAccordionItem>
                  <SfAccordionItem v-if="goodInfos && goodInfos.length" :header="$t('Additional_info')" class="filters__accordion-item">
                    <div class="product__additional-info">
                      <div v-for="(info, i) in goodInfos" :key="info.info_id">
                        <SfProperty :key="i" :name="info.name" :value="info.value" class="product__property">
                          <template v-if="info.name === 'Category'" #value>
                            <SfButton class="product__property__button sf-button--text">
                              {{ info.value }}
                            </SfButton>
                          </template>
                          <template v-if="info.name === 'Documents'" #value>
                            <template v-if="info.value && info.value.length">
                              <div>
                                <span v-for="(documentDoc, j) in info.value.split(',')">
                                  <a :href="documentDoc" target="_blank" class="product__property__button sf-button--text">
                                    {{ $t('Download') }}{{ j }}
                                  </a>
                                </span>
                              </div>
                            </template>
                          </template>
                        </SfProperty>
                      </div>
                    </div>
                  </SfAccordionItem>
                  <!-- <SfAccordionItem :header="$t('Read_reviews')" class="filters__accordion-item">
                    <SfReview v-for="review in reviews" :key="reviewGetters.getReviewId(review)"
                      :author="reviewGetters.getReviewAuthor(review)" :date="reviewGetters.getReviewDate(review)"
                      :message="reviewGetters.getReviewMessage(review)" :max-rating="5"
                      :rating="reviewGetters.getReviewRating(review)" :char-limit="250" read-more-text="Read more"
                      hide-full-text="Read less" class="product__review" />
                  </SfAccordionItem> -->
                </SfAccordion>
              </div>
          </div>
        </LazyHydrate>
      </div>
    </div>
    <LazyHydrate when-visible>
      <div>
        <SfSection :title-heading="$t('Description')" class="description"
        v-if="markedGet(productGetters.getDescription(product))">
        <div class="ItemInfo-description" v-html="markedGet(productGetters.getDescription(product))"></div>
      </SfSection>
      </div>
    </LazyHydrate>
    <div class="reatingContent" v-if="reviewTotal">
        <SfSection id="ReadReviews" :title-heading="$t('Read_reviews')" class="ReadReviewsDescription">
          <template #default>
            <div >
              <div class="ratingRow">
                <div style="display: flex;justify-content: center;flex-direction: column;">
                  <div style="display:flex;align-items: center;"><SfRating style="--icon-size: 1rem;" :score="averageRating" :max="5" /> <div style="margin-left:1rem;font-size:11pt;">{{ $t('reviewOutOf', {rating: averageRating}) }}</div></div>
                  <div style="margin-top: 0.5rem;" v-if="reviewTotal">{{ $t('BasedOnTotalReviews', {total: reviewTotal}) }}</div>
                </div>
                <div  v-if="CommentLevelRes">
                  <div v-for="commentLevel in CommentLevelRes.comment_level" style="margin-bottom:1rem;">
                    <div style="display:flex;align-items: center;justify-content: space-between;">
                      <SfRating :score="commentLevel.grade" :max="5" />
                      <Progress style="width:60%;" :hideInfo="true" :percent="Number((commentLevel.count / reviewTotal * 100).toFixed(0))"></Progress>
                      <div style="width: 2rem;text-align: left;"> {{ commentLevel.count }} </div>
                    </div>
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: center;">
                  <SfButton @click="goLink('/my-account/History?open=1')" >{{ $t('Write_a_review') }}</SfButton>
                </div>
              </div>
            </div>
          </template>
        </SfSection>
        <div v-if="reviews && reviews.length">
          <div style="font-size:13pt;text-align: center;display:flex;align-items: center;justify-content: center;border-bottom: 1px solid #BFBFBF;padding-bottom: 1rem;margin-bottom: 2rem;">{{ $t('reviewMostRecent') }}<span><SfIcon class="sf-header__icon" icon="chevron_down" color="#000" size="0.75rem" style="margin-left:1rem;" /></span></div>
        </div>
        <SfReview v-for="review in reviews" :key="reviewGetters.getReviewId(review)"
          :message="reviewGetters.getReviewMessage(review) " :max-rating="5"
          :rating="reviewGetters.getReviewRating(review)" :char-limit="250" read-more-text="Read more"
          class="product__review " >
          <template #author>
          <div style="display: flex;justify-content: space-between;">
            <div>{{ reviewGetters.getReviewAuthor(review) }}</div>
            <div>{{ getCuurentDate(reviewGetters.getReviewDate(review)) }}</div>
          </div>
          </template>
          <template #message>
            <div>
              <div>
                <collapsibeText :id="'collapsible-'+review.reviewId" :text="reviewGetters.getReviewMessage(review)" :maxLength="isMobile ? 100 : 600">
                </collapsibeText>
              </div>
              <div class="reviewDefault">
                 <div class="reviewImageList " style="display: flex;flex-wrap: wrap;gap: 1rem;">
                  <div v-if="review.videoUrl">
                    <video :autoplay="false" muted preload="load"
                      :src="review.videoUrl" :width="'100%'"
                      :height=" '100%'" style="object-position: top;max-height:180px;"
                      controls controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
                      <source :src="review.videoUrl" :type="'video/*'">
                    </video>
                  </div>
                  <!-- <Sf-image v-for="imgsrc in reviewGetters.getReviewImages(review)" style="--image-height:180px;object-fit: contain;margin:0;display: block;" :src="imgsrc" :alt="imgsrc" /> -->
                  <pre-image v-for="imgsrc in reviewGetters.getReviewImages(review)" :imageUrl="imgsrc" style="height:180px;" :key="imgsrc" />
                </div>
              </div>
              <div class="reviewCollpsible">
                 <div class="reviewImageList " >
                  <div v-if="review.videoUrl">
                    <video :autoplay="false" muted preload="load"
                      :src="review.videoUrl" :width="'100%'"
                      :height=" '100%'" style="object-position: top;max-height:180px;"
                      controls controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
                      <source :src="review.videoUrl" :type="'video/*'">
                    </video>
                  </div>
                  <div style="display: flex;flex-wrap: wrap;gap: 1rem;margin-top:1rem;">
                    <pre-image v-for="imgsrc in reviewGetters.getReviewImages(review)" :imageUrl="imgsrc" style="height:15vw;width:15vw;" :key="imgsrc" />
                  </div>
                  <!-- <Sf-image v-for="imgsrc in reviewGetters.getReviewImages(review)" style="--image-height:180px;object-fit: contain;margin:0;display: block;" :src="imgsrc" :alt="imgsrc" /> -->
                </div>
              </div>
            </div>
          </template>
        </SfReview>
        <div class="reviewCollpsible" v-if="false">
          <div v-for="review in reviews" :key="reviewGetters.getReviewId(review)">
            <!-- {{review}} -->
            <shoufengqin :id="''+review.reviewId">
              <template #title>
                <div style="display: flex;justify-content: space-between;">
                  <div>{{ reviewGetters.getReviewAuthor(review) }}</div>
                  <div>{{ getCuurentDate(reviewGetters.getReviewDate(review)) }}</div>
                </div>
              </template>
              <template #content>
                <div>
                  <div>
                    {{ reviewGetters.getReviewMessage(review) }}
                  </div>
                  <div class="reviewImageList" style="display: flex;flex-wrap: wrap;gap: 1rem;">
                    <div v-if="review.videoUrl">
                      <video :autoplay="false" muted preload="load"
                        :src="review.videoUrl" :width="'100%'"
                        :height=" '100%'" style="object-position: top;max-height:180px;"
                        controls controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
                        <source :src="review.videoUrl" :type="'video/*'">
                      </video>
                    </div>
                    <!-- <Sf-image v-for="imgsrc in reviewGetters.getReviewImages(review)" style="--image-height:180px;object-fit: contain;margin:0;display: block;" :src="imgsrc" :alt="imgsrc" /> -->
                    <pre-image v-for="imgsrc in reviewGetters.getReviewImages(review)" :imageUrl="imgsrc" style="height:180px;" :key="imgsrc" />
                  </div>
                </div>
              </template>
            </shoufengqin>
          </div>
        </div>
      </div>
    <LazyHydrate when-visible>
      <RelatedProducts style="margin-top:var(--spacer-sm)" :products="relatedProducts" :loading="relatedLoading" :title="$t('Match')" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <InstagramFeed />
    </LazyHydrate>
  </div>
</template>
<script>
import Progress from '~/components/util/progress.vue';
import {
  SfProperty,
  SfHeading,
  SfPrice,
  SfRating,
  SfSelect,
  SfAddToCart,
  SfTabs,
  SfIcon,
  SfImage,
  SfBanner,
  SfAlert,
  SfSticky,
  SfReview,
  SfBreadcrumbs,
  SfButton,
  SfColor,
  SfSection,
  SfAccordion
} from '@storefront-ui/vue';
import Gallery from '~/components/copy/Gallery.vue';
import InstagramFeed from '~/components/InstagramFeed.vue';
import RelatedProducts from '~/components/RelatedProducts.vue';
import { ref, computed, useRoute, useRouter, onMounted } from '@nuxtjs/composition-api';
import {
  useProduct,
  useOCart,
  productGetters,
  useReview,
  reviewGetters,
  useGoodSameList,
  useGoodCommentLevel,
  useApiError
} from '@bee-hole/coms';
import { onSSR } from '@vue-storefront/core';
import LazyHydrate from 'vue-lazy-hydration';
import { addBasePath } from '@vue-storefront/core';
import Sku from '~/components/Sku/Sku';
import { useCache, CacheTagPrefix } from '@bee-hole/cache';
// import typedTextWidthCursor from '~/components/typedTextWidthCursor';
import getDiscount from '~/components/Products/getDiscount';
import getPostage from '~/components/Products/getPostage.vue';
import wholesale from '~/components/Products/wholesale.vue';
import { useSystemStore } from '~/stores/system';
import { useUiState } from '~/composables';
import preImage from '~/components/util/preImage';
import shoufengqin from '~/components/util/shoufengqin.vue';
import collapsibeText from '~/components/util/collapsibeText.vue';
export default {
  name: 'Product',
  transition: 'fade',
  head() {
    const scripts = [];
    const video = this?.productGallery?.find((item) => item.fileType === 'video');
    const image = this?.productGallery?.find((item) => item.fileType === 'image');
    function convertUTCToLocalISO(utcDateString) {
      const date = new Date(utcDateString); // 创建 UTC 时间的 Date 对象

      // 获取当前时区的偏移
      const timezoneOffset = -date.getTimezoneOffset(); // 以分钟为单位
      const hoursOffset = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
      const minutesOffset = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
      const sign = timezoneOffset >= 0 ? '+' : '-';

      // 格式化日期为 ISO 字符串，不带毫秒
      const isoDateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}${sign}${hoursOffset}:${minutesOffset}`;

      return isoDateString;
    }
    if (video) {
      // console.log('video', this.product, convertUTCToLocalISO(this.product?.updateTime));
      scripts.push({
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": this?.product?.title,
          "description": String(this?.product?.title) + this?.product?.subTitle,
          "thumbnailUrl": image?.desktop.url,
          "uploadDate": convertUTCToLocalISO(this.product?.updateTime),
          "contentUrl": video?.desktop.url,
          "embedUrl": video?.desktop.url,
          "duration": "PT2M30S"
        }
      });
    }
    return {
      title: this?.product?.title,
      script: scripts,
      meta: [{
        name: 'keywords',
        content: this?.product?.keywords
      }]
    };
  },
  setup(props, context) {
    // const { user } = useUser();
    const galleryActive = ref(0);
    const getCuurentDate = context?.root?.$options?.getCuurentDate;
    const skuImage = ref('');
    const systemStore = useSystemStore();
    const qty = ref(1);
    const route = useRoute();
    const router = useRouter();
    const SfGallerGoodInfo = ref();
    const locale = ref();
    const { set: setError } = useApiError();
    const { isMobile } = useUiState();
    const { result: CommentLevelRes, goodCommentLevel } = useGoodCommentLevel();
    // 第一次sku手机端不弹窗
    const isMobileFirst = ref(false);
    // const { configs } = useConfig("mall_web_config");
    // const {
    //   products: relatedProducts,
    //   search: searchRelatedProducts,
    //   loading: relatedLoading
    // } = useProduct('relatedProducts');
    const { load: sameListGet, list: sameList, loading: relatedLoading } = useGoodSameList();
    const { addItem, loading } = useOCart();
    // const { goodWholesaleGet1 } = useWholesale();
    // 原评论
    // const { reviews: productReviews, search: searchReviews } = useReview('productReviews');
    const { reviews, search: searchReviews } = useReview('productReviews');
    const galleryVideo = ref();
    // const skuImageRef = ref();
    const id = computed(() => {
      if (route.value.params.id) {
        if (route.value.params.id.indexOf('-') !== -1) {
          const ids = route.value.params.id.split('-');
          return ids.length > 1 ? ids[1] : ids[0];
        } else {
          return route.value.params.id;
        }
      } else {
        return route.value.query.id;
      }
    });
    const { products: goods, search: loadGoods } = useProduct(id.value);
    const product = computed(() => productGetters.getGoods(goods.value?.list));
    const options = computed(() =>
      productGetters.getAttributes(goods.value, ['color', 'size'])
    );
    const CurrentSku = ref();
    const configuration = computed(() =>
      productGetters.getAttributes(product.value, ['color', 'size'])
    );
    const imageWidth = ref(620);
    // 店铺商品页备注
    const goodInfoRemark = computed(
      () => context?.root?.$options?.$mallConfig?.mall_web_config.goodInfoRemark
    );
    // const categories = computed(() =>
    //   productGetters.getCategoryIds(product.value)
    // );
    // const reviews = computed(() => reviewGetters.getItems(productReviews.value));

    // TODO: Breadcrumbs are temporary disabled because productGetters return undefined. We have a mocks in data
    const breadcrumbs = computed(() =>
      productGetters.newGetBreadcrumbs
        ? productGetters.newGetBreadcrumbs(product.value).map((item) => {
          if (item.text === 'Home') {
            item.text = context.root.$i18n.t(item.text);
          }
          item.link = context.root.context.localePath(item.link);
          return item;
        })
        : props.fallbackBreadcrumbs
    );
    const productGallery = computed(() =>
      productGetters.getGallery(product.value).map((img) => {
        const match = img.big.toLowerCase().match(/\.([a-z0-9]+)(?:\?|$)/i);
        let type = '';
        const fileType = match ? match[1] : '';
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
          type = 'image';
        } else if (['mp4', 'mov', 'avi', 'wmv'].includes(fileType)) {
          type = 'video';
        } else {
          type = 'image';
        }
        return ({
          mobile: { url: addBasePath(img.small) },
          desktop: { url: addBasePath(img.normal) },
          big: { url: addBasePath(img.big) },
          alt: product.value.title,
          fileType: type,
          houzhui: fileType
        });
      })
    );
    console.log('productGallery', productGallery.value);
    const go = (index) => {
      galleryActive.value = index;
      const skuImg = document.getElementById('goodsfGalleryBigSku' + index);
      if (skuImg) {
        skuImg.style.display = 'none';
      }
      SfGallerGoodInfo.value?.go(index);
      skuImage.value = productGallery.value[index]?.big?.url;
      if (productGallery.value?.[index]?.fileType === 'video') {
        const element = document.getElementById('goodsfGalleryBig' + index);
        if (element && element.tagName.toLowerCase() === 'video') {
          element.play();
        }
      }
    };
    const goLink = (link) => {
      if (link && link !== '') {
        link = link?.replace(/\s/g, '');
        if ((link?.indexOf('http') !== -1 || link?.indexOf('https') !== -1)) {
          return window.open(link + '/' + locale.value, '_blank');
        } else {
          return router.push(context.root.localePath(link));
        }
      }
    };
    const addGoogleItem = ()=>{
      const googleItemInfo = {
        currency: context?.root?.$cookies?.get('vsf-currency'),
        value: goods.value?.list?.[0]?.priceMin,
        items: []
      };
      googleItemInfo.items.push({
        item_id: goods.value?.list?.[0]?.goodId,
        item_name: goods.value?.list?.[0]?.goodName,
        price: goods.value?.list?.[0]?.priceMin,
        item_variant: goods.value?.list?.[0]?.skuName,
        quantity: 1
      });
      context.root.$gtm.push(
        {
          event: "view_item",
          ecommerce: googleItemInfo
        });
    };
    const { addTags } = useCache();
    onSSR(async () => {
      await loadGoods({ goodId: id.value });
      // await goodWholesaleGet1({ good_id: id.value });
      // await searchRelatedProducts({ catId: [categories.value[0]], limit: 8 });
      await sameListGet({ cId: product?.value?.cId, goodId: product.value?.goodId });
      await goodCommentLevel({ good_id: id.value });
      // await searchReviews({ productId: id.value });
      await searchReviews({ goods_id: id.value });
      if (goods.value && goods.value?.list?.length) {
        addGoogleItem();
      }
      if (!goods.value || !goods?.value?.list?.length) {
        context?.root?.$nuxt?.error({ statusCode: 404, title: 'goodinfo_null', description: 'goodinfo_null_des' });
      } else {
        try {
          addTags([
            { prefix: CacheTagPrefix.Product, value: id.value, dataPrefix: context.root.$options.$storeConfig?.mall_cache_pre }
          ]);
        } catch (e) {
          // console.log('err', e);
        }
      }
    });
    const updateFilter = (filter) => {
      router.push({
        path: route.value.path,
        query: {
          ...configuration.value,
          ...filter
        }
      });
    };
    const showSkuImage = () => {
      const skuImg = document.getElementById('goodsfGalleryBigSku' + galleryActive.value);
      if (skuImg) {
        skuImg.style.display = 'block';
        skuImg.style.position = 'absolute';
        skuImg.style.zIndex = '99999';
        skuImg.style.background = '#ffffff';
      }
    };
    const selectSku = (Result) => {
      CurrentSku.value = Result?.sku || null;
      CurrentSku.value = Object.assign({}, CurrentSku.value);
      if (CurrentSku.value?.price) {
        CurrentSku.value.price = Number(CurrentSku.value.price).toFixed(2);
        if (!CurrentSku.value?.skuImage) {
          return false;
        }
        if ((systemStore.isMobile && window.innerWidth < 510) || isMobile.value) {
          if (!isMobileFirst.value) {
            isMobileFirst.value = true;
            return false;
          }
          if (skuImage.value !== CurrentSku.value?.skuImage) {
            skuImage.value = CurrentSku.value?.skuImage;
            setError({
              code: 0,
              image: CurrentSku.value?.skuImage,
              time: 10000,
              sku: CurrentSku.value
            });
          }
        } else if (skuImage.value !== CurrentSku.value?.skuImage) {
          if (!isMobileFirst.value) {
            isMobileFirst.value = true;
            return false;
          }
          showSkuImage();
          skuImage.value = CurrentSku.value?.skuImage;
        }
      }
    };
    const markedGet = (val) => {
      return val;
    };
    onMounted(() => {
      if (systemStore.isMobile || window.innerWidth < 768) {
        if (window.innerWidth < 510) {
          imageWidth.value = window.innerWidth;
          // SfGallerGoodInfo.value.style['--active-image-height'] = imageWidth.value + 'px';
        } else {
          const width = window.innerWidth > 1214 ? 620 : ((window.innerWidth - 120) / 2) - 30;
          imageWidth.value = width > 620 ? 620 : width;
          // SfGallerGoodInfo.value.style['--active-image-height'] = imageWidth.value + 'px';
        }
      } else {
        const width = window.innerWidth > 1214 ? 620 : ((window.innerWidth - 120) / 2) - 30;
        imageWidth.value = width > 620 ? 620 : width;
        // SfGallerGoodInfo.value.style['--active-image-height'] = imageWidth.value + 'px';
      }
      galleryVideo.value?.[0]?.addEventListener('loadeddata', () => {
        // 视频加载完后立即暂停
        galleryVideo.value[0].currentTime = 0;
        // 等到视频seeked到第一帧时暂停
        galleryVideo.value?.[0]?.addEventListener('seeked', () => {
          galleryVideo.value[0].pause();
        });
      });
      const videoBig = document.getElementById('goodsfGalleryBig0');
      // 判断是否是视频
      if (videoBig && videoBig.tagName.toLowerCase() === 'video') {
        videoBig.removeAttribute('controls');
        videoBig.addEventListener('seeked', () => {
          setTimeout(() => {
            videoBig.play();
            videoBig.setAttribute('controls', 'controls');
          }, 1500);
        });
        // 当用户点击视频时显示控件
        videoBig.addEventListener('click', () => {
          videoBig.setAttribute('controls', 'controls');
        });
      }
      if (productGallery.value) {
        setTimeout(() => {
          go(0);
        }, 1000);
      }
      locale.value = context?.root?.$cookies?.get('vsf-locale');
    });
    return {
      updateFilter,
      configuration,
      product,
      reviews,
      reviewGetters,
      averageRating: computed(() =>
        productGetters.getAverageRating(product.value)
      ),
      // totalReviews: computed(() => productGetters.getTotalReviews(product.value)),
      totalReviews: computed(() => reviews.value.length),
      relatedProducts: computed(() =>
        productGetters.getImages(sameList?.value?.list)
      ),
      relatedLoading,
      options,
      qty,
      addItem,
      loading,
      productGetters,
      productGallery,
      breadcrumbs,
      sameList,
      goodInfos: computed(() => goods?.value?.list?.length ? goods?.value?.list[0]?.goodInfos?.filter((item) => item.is_rich_text === 0) : []),
      goodInfosVhtml: computed(() => {
        return goods?.value?.list?.length ? goods?.value?.list[0]?.goodInfos?.filter((item) => item.is_rich_text === 1) : [];
      }),
      selectSku,
      CurrentSku,
      markedGet,
      go,
      SfGallerGoodInfo,
      goLink,
      locale,
      imageWidth,
      CommentLevelRes,
      reviewTotal: computed(() => {
        let total = 0;
        if (CommentLevelRes.value) {
          CommentLevelRes.value?.comment_level?.map((item) => {
            total += item.count;
          });
        }
        return total;
      }),
      skuImage,
      getCuurentDate,
      isMobile,
      goodInfoRemark,
      galleryVideo
    };
  },
  components: {
    SfAlert,
    SfColor,
    SfProperty,
    SfHeading,
    SfPrice,
    SfRating,
    SfSelect,
    SfAddToCart,
    SfTabs,
    Gallery,
    SfIcon,
    SfImage,
    SfBanner,
    SfSticky,
    SfReview,
    SfBreadcrumbs,
    SfButton,
    InstagramFeed,
    RelatedProducts,
    LazyHydrate,
    Sku,
    SfSection,
    getDiscount,
    getPostage,
    wholesale,
    SfAccordion,
    Progress,
    preImage,
    shoufengqin,
    collapsibeText
  },
  data() {
    return {
      stock: 5,
      properties: [
      ],
      description:
        '',
      detailsIsActive: false,
      brand:
        '',
      careInstructions: ''
      // breadcrumbs: [
      //   {
      //     text: 'Home',
      //     route: {
      //       link: '/'
      //     }
      //   },
      //   {
      //     text: 'Category',
      //     route: {
      //       link: '/c/'
      //     }
      //   }
      // ]
    };
  }
};
</script>

<style lang="scss" scoped>
#product {
  box-sizing: border-box;

  @include for-desktop {
    max-width: 1272px;
    margin: 0 auto;
  }
}

.description {
  margin-top: 20px;
  margin-bottom: 20px;
  @include for-mobile{
    border-top:0  !important;
  }
  img {
    margin: 0 !important;
  }
  .ItemInfo-description{
    img{
      display: block;
    }
  }
}
.ReadReviewsDescription{
  margin-top: 20px;
  margin-bottom: 20px;
  @include for-mobile{
    border-top:0  !important;
  }
}

.goodPostage {
  @include for-mobile {
    margin: 0 var(--spacer-sm);
    margin-bottom: var(--spacer-sm);
    margin-right:0;
  }

  margin-bottom:var(--spacer-sm);
}

.product {
  @include for-desktop {
    display: flex;
  }
  &__info {
    margin: var(--spacer-sm) auto;

    @include for-desktop {
      max-width: 32.625rem;
      margin: 0 0 0 7.5rem;
    }
    @include for-mobile {
      margin: 0 ;
    }
  }

  &__header {
    --heading-title-color: var(--c-link);
    --heading-title-font-weight: var(--font-weight--bold);
    --heading-padding: 0;
    margin: 0 var(--spacer-sm);
    display: flex;
    justify-content: space-between;

    @include for-desktop {
      --heading-title-font-weight: var(--font-weight--semibold);
      margin: 0 auto;
    }
  }

  &__drag-icon {
    animation: moveicon 1s ease-in-out infinite;
  }

  &__price-and-rating {
    margin: 0 var(--spacer-sm) var(--spacer-sm);
    align-items: center;

    @include for-desktop {
      display: flex;
      justify-content: space-between;
      margin: var(--spacer-sm) 0 var(--spacer-sm) 0;
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: var(--spacer-xs) 0 var(--spacer-xs);
  }

  &__count {
    @include font(--count-font,
      var(--font-weight--normal),
      var(--font-size--sm),
      1.4,
      var(--font-family--secondary));
    color: var(--c-text);
    text-decoration: none;
    margin: 0 0 0 var(--spacer-xs);
  }

  &__description {
    @include font(--product-description-font,
      var(--font-weight--light),
      var(--font-size--base),
      1.6,
      var(--font-family--primary));
    @include for-mobile{
      margin: 0 var(--spacer-sm);;
    }
  }

  &__select-size {
    margin: 0 var(--spacer-sm);

    @include for-desktop {
      margin: 0;
    }
  }

  &__colors {
    @include font(--product-color-font,
      var(--font-weight--normal),
      var(--font-size--lg),
      1.6,
      var(--font-family--secondary));
    display: flex;
    align-items: center;
    margin-top: var(--spacer-xl);
  }

  &__color-label {
    margin: 0 var(--spacer-lg) 0 0;
  }

  &__color {
    margin: 0 var(--spacer-2xs);
  }

  &__add-to-cart {
    margin: var(--spacer-base) var(--spacer-sm) 0;

    @include for-desktop {
      margin-top: var(--spacer-2xl);
    }
  }

  &__guide,
  &__compare,
  &__save {
    display: block;
    margin: var(--spacer-xl) 0 var(--spacer-base) auto;
  }

  &__compare {
    margin-top: 0;
  }

  &__tabs {
    --tabs-title-z-index: 0;
    margin: var(--spacer-sm) auto var(--spacer-sm);
    --tabs-title-font-size: var(--font-size--lg);

    @include for-desktop {
      margin-top: var(--spacer-2xl);
    }
  }

  &__property {
    margin: var(--spacer-base) 0;

    &__button {
      --button-font-size: var(--font-size--base);
    }
  }

  &__review {
    padding-bottom: 24px;
    border-bottom: var(--c-light) solid 1px;
    margin-bottom: var(--spacer-base);
    @include for-mobile{
      margin-top: var(--spacer-lg)
    }
  }

  &__additional-info {
    color: var(--c-link);
    @include font(--additional-info-font,
      var(--font-weight--light),
      var(--font-size--sm),
      1.6,
      var(--font-family--primary));

    &__title {
      font-weight: var(--font-weight--normal);
      font-size: var(--font-size--base);
      margin: 0 0 var(--spacer-sm);

      &:not(:first-child) {
        margin-top: 3.5rem;
      }
    }

    &__paragraph {
      margin: 0;
    }
  }

  &__gallery {
    flex: 1;
  }
}

.breadcrumbs {
  margin: var(--spacer-base) auto var(--spacer-lg);
}

@keyframes moveicon {
  0% {
    transform: translate3d(0, 0, 0);
  }

  50% {
    transform: translate3d(0, 30%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.section {
  --section-margin: var(--spacer-lg);
}
</style>
<style lang="scss">
.sf-review{
  --review-max-width: 100vw;
}
.ratingRow{
  display: grid;
  @include for-mobile {
    grid-template-columns: repeat(1, 1fr);
    gap:1rem;
  }
  @include for-desktop {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
}
#product {
  .reatingContent{
    @include for-mobile {
      margin: 0 var(--spacer-sm);
      margin-bottom: var(--spacer-sm);
    }
  }
  .sf-product-card__image {
    .sf-image.sf-image-loaded {
      object-fit: contain;
      object-position: top;
    }
  }
  .description {
    @include for-mobile {
      img {
        width: 100%;
      }
    }

    @include for-desktop {
      img {
        width: 48%;
        margin: 0%;
        // margin:0 auto;
        // display: block;
      }
    }
    .ItemInfo-description{
      img{
        display: block;
      }
    }
  }
  .ReadReviewsDescription{
     @include for-mobile {
      img {
        width: 100%;
      }
    }

    @include for-desktop {
      img {
        width: 48%;
        margin: 1%;
        // margin:0 auto;
        // display: block;
      }
    }
  }
  .productAcction{
    .sf-accordion-item{
      border-top: 1px solid #CFCFCF;
      .sf-accordion-item__header{
        height: 60px;
        font-weight: 600;
      }
    }
  }
  .sf-section{
    @include for-desktop{
      --section-content-margin: var(--spacer-xl) 0 0 0;
    }
    @include for-mobile{
      border-top:1px solid var(--c-primary);
      padding-top: var(--spacer-sm);
      .sf-heading{
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
    &__content{
      @include for-desktop{
        margin: var(--section-content-margin, calc(var(--spacer-lg)* 1) 0 0 0);
      }
      @include for-mobile{
        margin: var(--section-content-margin, calc(var(--spacer-sm)* 1) 0 0 0);
      }
    }
  }
  .InstagramFeed {
    margin-top: 0;
    padding-top: 0;
    .sf-section__content{
      margin-top: 0;
    }
  }
  .reviewImageList{
    margin-top: var(--spacer-sm);
    .sf-image--wrapper{
      img{
        border: 1px solid #BFBFBF;
      }
    }
  }
  .reviewCollpsible{
    @include for-desktop{
      display: none;
    }
    @include for-mobile{
      display: block;
    }
  }
  .reviewDefault{
    @include for-desktop{
      display: block;
    }
    @include for-mobile{
      display: none;
    }
  }
  .productRemark{
    margin-bottom: var(--spacer-lg);
    @include for-mobile{
      margin: 0 var(--spacer-sm) var(--spacer-sm);
    }
  }
}
</style>
